;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import styles from "./styles.module.scss"

import {
  BLACK_COLOR,
  YELLOW_COLOR,
  PRIMARY_YELLOW_BUTTON_TYPE,
  PRIMARY_BLACK_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../constants"
import PrimaryButton from "../PrimaryButton"
import SecondaryButton from "../SecondaryButton"

/*
    // button1, button2
    button format: 
    {
        type:  [PRIMARY_YELLOW, PRIMARY_BLACK, SECONDARY]
        text,
        onClick,
        href
    }

*/
function PrimaryAndSecondaryButtonsContainer({ button1, button2 }) {
  const renderButton = (button) => {
    switch (button.type) {
      case PRIMARY_YELLOW_BUTTON_TYPE:
        return (
          <PrimaryButton
            color={YELLOW_COLOR}
            text={button.text}
            href={button.href}
            onClick={button.onClick}
          />
        )
      case PRIMARY_BLACK_BUTTON_TYPE:
        return (
          <PrimaryButton
            color={BLACK_COLOR}
            text={button.text}
            href={button.href}
            onClick={button.onClick}
          />
        )
      case SECONDARY_BUTTON_TYPE:
        return (
          <SecondaryButton
            text={button.text}
            href={button.href}
            onClick={button.onClick}
          />
        )
    }
  }
  return (
    <div className={`${styles["buttons-container-outer"]}`}>
      <div className={styles["buttons-container"]}>
        {renderButton(button1)}
        {renderButton(button2)}
      </div>
    </div>
  )
}

export default PrimaryAndSecondaryButtonsContainer
